let StripWhiteSpaceDirective = () => {
    return {
        restrict: 'A',
        scope: {
            scanType: '=',
            onPressEnter: '&'
        },
        require: {
            ngModel: 'ngModel'
        },
        link: function (scope, element, attrs, controller) {
            const ENTER_KEY_CODE = 13
            let modelValue;
            const stripWhiteSpace = () => {
                if (controller.ngModel.$modelValue) {
                    modelValue = controller.ngModel.$modelValue.trim();
                }

                if (!controller.ngModel.$modelValue) {
                    return;
                }

                controller.ngModel.$$rawModelValue = modelValue;
                controller.ngModel.$viewValue = modelValue;
                controller.ngModel.$commitViewValue();
                controller.ngModel.$render()
            }

            element.on('keypress', function (event) {
                if (event.keyCode === ENTER_KEY_CODE) {
                    // event.preventDefault();
                    // event.stopPropagation();
                    stripWhiteSpace()

                    setTimeout(() => {
                        scope.onPressEnter();
                    }, 500);
                }
            })

            element.on('blur', function () {
                stripWhiteSpace()
            })
        }
    }
}

export default StripWhiteSpaceDirective;



// WEBPACK FOOTER //
// ./client/app/common/strip-whitespace/strip-whitespace.directive.js